import React from 'react';
import './SocialLoginDisplayComponent.less';
import authAccountTypes from '../../enums/AuthAccountTypes';
import GoogleAuthComponent from '../GoogleAuthComponent/GoogleAuthComponent';
import FacebookAuthComponent from '../FacebookAuthComponent/FacebookAuthComponent';
import CreatePasswordComponent from '../CreatePasswordComponent/CreatePasswordComponent';
import ExpediaAuthComponent from '../ExpediaAuthComponent/ExpediaAuthComponent';

function SocialLoginPageDisplayComponent({authAccountType, emailAddress, handleError, lingua, marketingOptOut, multiUserEnabled, onClose, performBulkPageUpdate, service, setAuthJson, site, token, updatePage}) {
    const header = lingua.read('lex.social.login.card.header2');
    const muHeader = lingua.read('lex.social.login.card.muHeader');
    const hasExpedia = authAccountType.indexOf(authAccountTypes.EXPEDIA) !== -1;
    const hasFacebook = authAccountType.indexOf(authAccountTypes.FACEBOOK) !== -1;
    const hasGoogle = authAccountType.indexOf(authAccountTypes.GOOGLE) !== -1;
    const hasSocial = hasExpedia || hasFacebook || hasGoogle;
    const createPassword =
        <div>
            <CreatePasswordComponent
                lingua={lingua}
                updatePage={updatePage}
                handleError={handleError}
                service={service}
                emailAddress={emailAddress}
                displayButton={!!multiUserEnabled}
            />
        </div>;

    if (multiUserEnabled) {
        return (
            <div className="text-center">
                <div className="Existing-social-mu"> {muHeader} </div>
                {hasSocial && createPassword}
            </div>
        );
    }

    return (
        <div className="text-center">
            <div>
                <div className="Select-your-social-a"> {header} </div>
            </div>
            <div className="SocialButtons">
                {hasExpedia &&
                    <ExpediaAuthComponent
                        authStatus
                        lingua={lingua}
                        handleError={handleError}
                        onClose={onClose}
                        setAuthJson={setAuthJson}
                        performBulkPageUpdate={performBulkPageUpdate}
                        site={site}
                        token={token}
                        emailAddress={emailAddress}
                        marketingOptOut={marketingOptOut}
                    />
                }
                {hasGoogle &&
                    <GoogleAuthComponent
                        authStatus
                        lingua={lingua}
                        handleError={handleError}
                        onClose={onClose}
                        setAuthJson={setAuthJson}
                        performBulkPageUpdate={performBulkPageUpdate}
                        site={site}
                        token={token}
                        emailAddress={emailAddress}
                        marketingOptOut={marketingOptOut}
                    />
                }
                {hasFacebook &&
                    <FacebookAuthComponent
                        authStatus
                        lingua={lingua}
                        handleError={handleError}
                        onClose={onClose}
                        setAuthJson={setAuthJson}
                        performBulkPageUpdate={performBulkPageUpdate}
                        site={site}
                        token={token}
                        emailAddress={emailAddress}
                        marketingOptOut={marketingOptOut}
                    />
                }
            </div>
            {hasSocial && createPassword}
        </div>
    );
}

export default SocialLoginPageDisplayComponent;
